import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Meta } from "../../Components/Helpers/Meta";
import { Navbar } from "../../Components/Navbar/Navbar";

const Quality = () => {
  const { t } = useTranslation();
  const language = i18next.language;
  const { lang } = useParams();

  //   useEffect(() => {
  //     if (lang) {
  //         i18next.changeLanguage(lang);
  //     }
  //     const updateTitle = () => {
  //         document.title = `${t("quality")} - Cevher`;
  //       };

  //       updateTitle();

  //       const handleLanguageChanged = () => {
  //         updateTitle();
  //       };

  //       i18next.on("languageChanged", handleLanguageChanged);

  //       return () => {
  //         i18next.off("languageChanged", handleLanguageChanged);
  //       };
  //     }, [lang]);

  return (
    <div>
      <Meta
        title={t("development-quality-title")}
        description={t("development-quality-ourvision-desc")}
        lang={lang}
      />
      <Navbar />
      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/quality.de63555a.jpg")}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div
                className="c-caption-section"
                style={{ color: "#fff", textAlign: "center" }}
              >
                {t("developmentandproduction")}
              </div>
              <h1 className="c-caption-header">{t("quality")}</h1>
            </div>
          </div>
        </div>
        <div className="c-container">
          <div className="c-col--offset-lg-2 c-col--lg-8">
            <div style={{ marginTop: "2.5rem" }}>
              <p>
                <strong>{t("development-quality-title")}</strong>
              </p>
            </div>
            <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
              <div style={{ marginBottom: "1rem" }}>
                <strong>{t("development-quality-ourvision")}</strong>
              </div>
              <p>{t("development-quality-ourvision-desc")}</p>
            </div>
            <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
              <div style={{ marginBottom: "1rem" }}>
                <strong>{t("development-quality-ourmission")}</strong>
              </div>
              <ul className="c-list" style={{ listStyle: "inside" }}>
                <li className="c-list-item">
                  {t("development-quality-ourmission-1")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-2")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-3")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-4")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-5")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-6")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-7")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-8")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-9")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-10")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourmission-11")}
                </li>
              </ul>
            </div>
            <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
              <div style={{ marginBottom: "1rem" }}>
                <strong>{t("development-quality-ourvalues")}</strong>
              </div>
              <ul
                className="c-list"
                style={{
                  columnCount: 2,
                  columnGap: "2rem",
                  listStyle: "inside",
                }}
              >
                <li className="c-list-item">
                  {t("development-quality-ourvalues-1")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourvalues-2")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourvalues-3")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourvalues-4")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourvalues-5")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-ourvalues-6")}
                </li>
              </ul>
            </div>
            <div>
              <div className="c-row row--no-gutter">
                <div className="c-col c-col--lg-6">
                  <img
                    src={require("../../assets/content/1- CASS Testi - Salt Spray and Alternating Climate Test.jpg")}
                    alt=""
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
                <div className="c-col c-col--lg-6">
                  <img
                    src={require("../../assets/content/2- Cok Eksenli Yorulma Testi (Multi-Axial Fatigue Test (ZWARP)).jpg")}
                    alt=""
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              </div>
              <div
                className="c-row row--no-gutter"
                style={{ marginTop: "1.5rem" }}
              >
                <div className="c-col c-col--lg-12">
                  <img
                    src={require("../../assets/content/4- 3D Olcum Cihazi (3D Measurement Device).jpg")}
                    alt=""
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }} />
        <div className="c-container">
          <div className="c-col--offset-lg-2 c-col--lg-8">
            <div style={{ fontSize: "2em", fontWeight: "bold" }}>
              {t("development-quality-testing")}
            </div>
            <div>{t("development-quality-testing-desc")}</div>
            <div
              style={{
                fontSize: "2em",
                fontWeight: "bold",
                marginTop: "1.5rem",
              }}
            >
              {t("development-quality-list-title")}
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <div style={{ maxWidth: "50%", flex: "0 0 50%" }}>
                <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
                  <div style={{ marginBottom: "1rem" }}>
                    <strong>{t("development-quality-mechanical")}</strong>
                  </div>
                  <ul className="c-list" style={{ listStyle: "none" }}>
                    <li className="c-list-item">
                      {t("development-quality-mechanical-0")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-mechanical-1")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-mechanical-2")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-mechanical-3")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-mechanical-4")}
                    </li>
                  </ul>
                </div>
                <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
                  <div style={{ marginBottom: "1rem" }}>
                    <strong>{t("production")}</strong>
                  </div>
                  <ul className="c-list" style={{ listStyle: "none" }}>
                    <li className="c-list-item">
                      {t("development-quality-production-1")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-production-2")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-production-3")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-production-4")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-production-5")}
                    </li>
                  </ul>
                </div>
                <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
                  <div style={{ marginBottom: "1rem" }}>
                    <strong>{t("development-quality-dimensional")}</strong>
                  </div>
                  <ul className="c-list" style={{ listStyle: "none" }}>
                    <li className="c-list-item">
                      {t("development-quality-dimensional-1")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-dimensional-2")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-dimensional-3")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-dimensional-4")}
                    </li>
                  </ul>
                </div>
              </div>
              <div style={{ maxWidth: "50%", flex: "0 0 50%" }}>
                <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
                  <div style={{ marginBottom: "1rem" }}>
                    <strong>{t("development-quality-metallurgy")}</strong>
                  </div>
                  <ul className="c-list" style={{ listStyle: "none" }}>
                    <li className="c-list-item">
                      {t("development-quality-metallurgy-1")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-metallurgy-2")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-metallurgy-3")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-metallurgy-4")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-metallurgy-5")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-metallurgy-6")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-metallurgy-7")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-metallurgy-8")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-metallurgy-9")}
                    </li>
                  </ul>
                </div>
                <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
                  <div style={{ marginBottom: "1rem" }}>
                    <strong>{t("development-quality-point")}</strong>
                  </div>
                  <ul className="c-list" style={{ listStyle: "none" }}>
                    <li className="c-list-item">
                      {t("development-quality-point-1")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-2")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-3")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-4")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-5")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-6")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-7")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-8")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-9")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-10")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-11")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-12")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-13")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-14")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-15")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-16")}
                    </li>
                    <li className="c-list-item">
                      {t("development-quality-point-17")}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }} />
        <div className="c-container">
          <div className="c-col--offset-lg-2 c-col--lg-8">
            <div style={{ marginBottom: "6rem" }}>
              <div style={{ fontSize: "1.5em", fontWeight: "500" }}>
                {t("development-quality-certificates")}
              </div>
              <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
                {t("development-quality-certificates-desc")}
              </div>
              <ul className="c-list" style={{ listStyle: "inside" }}>
                <li className="c-list-item">TISAX</li>
                <li className="c-list-item">
                  {t("development-quality-certificates-1")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-2")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-3")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-4")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-5")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-6")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-7")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-11")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-8")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-9")}
                </li>
                <li className="c-list-item">
                  {t("development-quality-certificates-10")}
                </li>
                {/* <li className="c-list-item">
                                    {t("certificate-of-registration")}
                                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className="c-container">
          <div className="c-col--offset-lg-2 c-col--lg-8">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <a
                href="https://cevher.com/static/docs/TISAX.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={require("../../assets/certificates/TISAX.png")}
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href="https://cevher.com/static/docs/ISO27001.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={require("../../assets/certificates/ISO27001.png")}
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/GHG-Cevher.png")
                    : require("../../assets/certificates/GHG-Cevher.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/GHG-Cevher.png")
                      : require("../../assets/certificates/GHG-Cevher.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/14064-Cevher-ENG.png")
                    : require("../../assets/certificates/14064-Cevher-TR.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/14064-Cevher-ENG.png")
                      : require("../../assets/certificates/14064-Cevher-TR.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/9100WA_EN.jpg")
                    : require("../../assets/certificates/9100WA_EN.jpg")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/9100WA_EN.jpg")
                      : require("../../assets/certificates/9100WA_EN.jpg")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              {/* <a
                                href={
                                    language === "en"
                                        ? require("../../assets/certificates/EN9100_Fab2.png")
                                        : require("../../assets/certificates/EN9100_Fab2.png")
                                }
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={
                                        language === "en"
                                            ? require("../../assets/certificates/EN9100_Fab2.png")
                                            : require("../../assets/certificates/EN9100_Fab2.png")
                                    }
                                    alt=""
                                    className="c-logo"
                                />
                            </a> */}
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/IATF 16949_English-1.png")
                    : require("../../assets/certificates/IATF 16949_Turkish-1.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/IATF 16949_English-1.png")
                      : require("../../assets/certificates/IATF 16949_Turkish-1.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/ISO9001-CevherJant.jpg")
                    : require("../../assets/certificates/ISO9001-CevherJant.jpg")
                  // require("../../assets/certificates/ISO 9001-Cevher Jant-1.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/ISO9001-CevherJant.jpg")
                      : require("../../assets/certificates/ISO9001-CevherJant.jpg")
                    // require("../../assets/certificates/ISO 9001-Cevher Jant-1.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/ISO9001Annex-CevherJant.jpg")
                    : require("../../assets/certificates/ISO9001Annex-CevherJant.jpg")
                  // require("../../assets/certificates/Fab2_ISO9001_TR.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/ISO9001Annex-CevherJant.jpg")
                      : require("../../assets/certificates/ISO9001Annex-CevherJant.jpg")
                    // require("../../assets/certificates/Fab2_ISO9001_TR.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/ISO 14001 - Cevher Jant-1.png")
                    : require("../../assets/certificates/ISO 14001 - Cevher Jant-1.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/ISO 14001 - Cevher Jant-1.png")
                      : require("../../assets/certificates/ISO 14001 - Cevher Jant-1.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>

              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/ISO 14001 - Cevher Jant-2.png")
                    : require("../../assets/certificates/ISO 14001 - Cevher Jant-2.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/ISO 14001 - Cevher Jant-2.png")
                      : require("../../assets/certificates/ISO 14001 - Cevher Jant-2.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/CEVHER27001-page-1.png")
                    : require("../../assets/certificates/CEVHER27001-page-2.png")
                }
                target="-page-1ank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/CEVHER27001-page-1.png")
                      : require("../../assets/certificates/CEVHER27001-page-2.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>

              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/ISO 45001 - Cevher Jant-1.png")
                    : require("../../assets/certificates/ISO 45001 - Cevher Jant-1.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/ISO 45001 - Cevher Jant-1.png")
                      : require("../../assets/certificates/ISO 45001 - Cevher Jant-1.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>

              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/ISO 45001 - Cevher Jant-2.png")
                    : require("../../assets/certificates/ISO 45001 - Cevher Jant-2.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/ISO 45001 - Cevher Jant-2.png")
                      : require("../../assets/certificates/ISO 45001 - Cevher Jant-2.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>

              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/Cevher50001-page-1.png")
                    : require("../../assets/certificates/Cevher50001-page-1.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/Cevher50001-page-1.png")
                      : require("../../assets/certificates/Cevher50001-page-1.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/Cevher50001-page-2.png")
                    : require("../../assets/certificates/Cevher50001-page-2.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/Cevher50001-page-2.png")
                      : require("../../assets/certificates/Cevher50001-page-2.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/Cevher50001-page-3.png")
                    : require("../../assets/certificates/Cevher50001-page-3.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/Cevher50001-page-3.png")
                      : require("../../assets/certificates/Cevher50001-page-3.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/CEVHER JANT SA8000 Certificate-1.png")
                    : require("../../assets/certificates/CEVHER JANT SA8000 Certificate-1.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/CEVHER JANT SA8000 Certificate-1.png")
                      : require("../../assets/certificates/CEVHER JANT SA8000 Certificate-1.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>

              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/14046-Cevher.png")
                    : require("../../assets/certificates/14046-Cevher.png")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/14046-Cevher.png")
                      : require("../../assets/certificates/14046-Cevher.png")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
            </div>
            <div
              style={{
                marginTop: "1.5rem",
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <div className="col-6 col-md-3 mb-3">
                <div style={{ position: "relative", height: 125 }}>
                  <img
                    src={require("../../assets/certificates/tuv-nord.f51c13b3.png")}
                    alt="TUV Nord"
                    className="c-logo-img"
                  />
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div style={{ position: "relative", height: 125 }}>
                  <img
                    src={require("../../assets/certificates/tse.3c687945.png")}
                    alt="Turkish Standards Institute"
                    className="c-logo-img"
                  />
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div style={{ position: "relative", height: 125 }}>
                  <img
                    src={require("../../assets/certificates/din.544001fd.png")}
                    alt="DIN"
                    className="c-logo-img"
                  />
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div style={{ position: "relative", height: 125 }}>
                  <img
                    src={require("../../assets/certificates/sni.fc37a585.png")}
                    alt="SNI"
                    className="c-logo-img"
                  />
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div style={{ position: "relative", height: 125 }}>
                  <img
                    src={require("../../assets/certificates/astm.a6e265b3.png")}
                    alt="ASTM International"
                    className="c-logo-img"
                  />
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div style={{ position: "relative", height: 125 }}>
                  <img
                    src={require("../../assets/certificates/inmetro.7547c404.png")}
                    alt="INMETRO"
                    className="c-logo-img"
                  />
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div style={{ position: "relative", height: 125 }}>
                  <img
                    src={require("../../assets/certificates/social-accountability-accreditation-services.png")}
                    alt="Social Accountability Accreditation Services"
                    className="c-logo-img"
                    style={{
                      maxWidth: "80%",
                      height: "80%",
                      objectFit: "contain",
                    }} // mobilde küçültme
                  />
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                {/* c-col--lg-2 c-col--xs-6 */}
                <div style={{ position: "relative", height: 125 }}>
                  <img
                    src={require("../../assets/certificates/SA8000-certification.png")}
                    alt="SA8000 Certificate"
                    className="c-logo-img"
                    style={{
                      maxWidth: "80%",
                      height: "80%",
                      objectFit: "contain",
                    }} // mobilde küçültme
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quality;
